import styled from "styled-components";

// Colors pulled from CSS variables set on the Controller's <Page> wrapper so
// the button automatically inherits the active theme (light/dark) without
// needing a styled-components ThemeProvider. Fallback values match the
// original light palette in case this button is ever used somewhere that
// doesn't define the variables.
// A column flexbox, so the mobile variant can stack a slide thumbnail above the
// label inside the same button. `align-items: center` was already here but inert
// (no `display: flex` to act on); with the thumbnail it has to do real work, so
// the display mode is now explicit. Text-only callers are unaffected — a single
// centred child looks identical.
const NavButton = styled.button`
  background-color: var(--nav-bg, rgba(64, 87, 109, 0.07));
  color: var(--nav-text, rgba(36, 49, 61, 0.7));
  align-self: stretch;
  width: 100%;
  padding: 0 14px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* space-evenly, not center. With the thumbnail and the label centred as one
     block, the thumbnail read as sitting low — a lot of empty button above it
     and the pair floating past the middle. Equal gaps put the thumbnail's centre
     exactly halfway between the top edge and the label, which is where the eye
     expects it. (Falls back to plain centring for a text-only button: with a
     single child, space-evenly and center are the same thing.) */
  justify-content: space-evenly;
  gap: 8px;
  border: none;
  border-radius: 8px;
  box-sizing: border-box;
  max-width: 100%;
  font-family: inherit;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
  /* The thumbnail is decoration on a control the user taps under time pressure;
     a half-drawn image must never delay or displace the label. */
  overflow: hidden;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
  &:hover:enabled {
    background-color: var(--nav-bg-hover, rgba(64, 87, 109, 0.15));
  }
`;

export default NavButton;
